export const checkIfKeyExists = (a, b, column) => {
  if (!a[column.dataIndex]) {
    return -1; // Change this values if you want to put `null` values at the end of the array
  }
  if (!b[column.dataIndex]) {
    return 1; // Change this values if you want to put `null` values at the end of the array
  }
};